{
  "google-salon-details-page": {
    "buttons": {
      "be-partner": "TRỞ THÀNH ĐỐI TÁC",
      "request": "YÊU CẦU"
    },
    "text": {
      "is-customer-question": "Bạn là khách hàng của tiệm?",
      "is-customer-hint": "Nếu bạn muốn tính năng đặt lịch trực tuyến cho tiệm, vui lòng cho chúng tôi biết và chúng tôi sẽ liên hệ với chủ tiệm.",
      "is-owner-question": "Bạn là chủ tiệm?",
      "is-owner-hint": "Hãy trở thành đối tác với chúng tôi để khám phá các tính năng không giới hạn của chúng tôi với ưu đãi ban đầu lớn!",
      "request-sent": "YÊU CẦU CỦA BẠN ĐƯỢC GỬI"
    }
  }
}
